import { useQuery } from '@apollo/client';

import { getCmsLocaleString } from 'js/lib/language';
import { useLocation } from 'js/lib/useRouter';

import type { GeneralAbout, GeneralAboutCollection } from 'bundles/about/__generated__/baseContentfulTypes';
import { AboutPageQuery } from 'bundles/about/queries';
import { getGrowthCmsGraphqlContext } from 'bundles/cms/utils/CmsUtils';

export type PageContent = GeneralAbout | undefined;

export const useAboutPageContentfulData = (slug: string) => {
  const location = useLocation();
  const previewParam = location.query.preview;
  const isPreview = !!previewParam && Number(previewParam) === 1;

  const { data } = useQuery<
    { generalAboutCollection: GeneralAboutCollection },
    { preview: boolean; slug: string; locale: string }
  >(AboutPageQuery, {
    variables: {
      preview: !!isPreview,
      slug,
      locale: getCmsLocaleString(),
    },
    context: getGrowthCmsGraphqlContext(isPreview),
  });

  return data?.generalAboutCollection?.items[0];
};

export default useAboutPageContentfulData;
